export default [
    {
        "name": "RFP",
        "sort": 0,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Level1",
        "sort": 1,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Level2",
        "sort": 2,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Level3",
        "sort": 3,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Level4",
        "sort": 4,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Level5",
        "sort": 5,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Without Contract",
        "sort": 6,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "Special Rate",
        "sort": 7,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    },
    {
        "name": "",
        "sort": 8,
        "rate": 0,
        "rooms": 0,
        "rev": 0,
        "adr": 0,
        "mix": 0,
    }
]


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-5/data.js